/**
 * Created by deepak on 22-Mar-18.
 */
import React, {Component} from 'react';
import Pagination from "react-js-pagination";
import {Link} from 'react-router-dom';
import ReactDOM from 'react-dom';
import {Redirect} from 'react-router-dom';
import Swal from 'sweetalert2'
import moment from 'moment';
import Errors from '../common/Errors';
import * as AppConstant from '../common/AppConstant'
import $ from 'jquery';
import RequiredAstrisk from '../common/RequiredAstrisk'
import InvalidAccessOrLogin from "../errorsPage/InvalidAccessOrLogin";

class DocTemplateList extends Component{

    constructor(props){
        super(props)
        this.state = {
            docTempates : [],
            blubillingConf: {},
            loggedInUser:{},
            activeNumber:1,
            count:0,
            apiStatus: {
                isError: false,
                message: '',
                messages: ''
            },
            apiStatus1: {
                isError: false,
                message: '',
                messages: ''
            },
            disabledButton: false,
            showLoader:false,
            selectTemplate : null,
            submitTemplate : null,
            templateNameError : null,
            descriptionError : null,
            numberOfRecipientError : null,
            showDiv: false,
            redirectToForbiddenPage: false
        }
        this.fetchAllDocTemplates = this.fetchAllDocTemplates.bind(this)
        this.handleDeleteTemplate = this.handleDeleteTemplate.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.copyTemplate = this.copyTemplate.bind(this)
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.changeRadioButton = this.changeRadioButton.bind(this)
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.handleShowAdvanceOptions = this.handleShowAdvanceOptions.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this)
    }

    componentDidMount(){
        this.fetchLoggedInStaff()
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    _this.setState({loggedInUser: json.staff}, function(){
                        _this.fetchAllDocTemplates(1);
                        _this.fetchBillingConfiguration()
                    })
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    handleChange(event) {
        const {submitTemplate} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        submitTemplate[name] = value;
        console.log(name + " === " + value + " ===  ");
        this.validateForm(name, value, null);
        this.setState({submitTemplate: submitTemplate});
    }
    checkBoxChange(value, name) {
        console.log("value="+value+", name="+name);
        if (value === true) {
            const {submitTemplate} = this.state;
            submitTemplate[name] = false;
            this.setState({submitTemplate: submitTemplate});
        } else {
            const {submitTemplate} = this.state;
            submitTemplate[name] = true;
            this.setState({submitTemplate: submitTemplate});
        }
    }
    changeRadioButton(value, name){
        const {submitTemplate} = this.state;
        submitTemplate[name] = value
        this.setState({submitTemplate: submitTemplate});
    }
    copyTemplate(id,e){
        const {apiStatus1}  = this.state;
        apiStatus1.isError = false;
        apiStatus1.message = '';
        this.setState({disabledButton: false, apiStatus1: apiStatus1});
        fetch(this.props.api + '/template/'+id, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.setState({showLoader: false, selectTemplate: null});
                    this.props.onLogoutClick(json.message);
                }else {
                    let resJson = json
                    resJson.templateName = "Copy of "+resJson.templateName
                    resJson.description = "Copy of "+resJson.description
                    this.setState({selectTemplate: json, submitTemplate :resJson});
                    this.setState({showLoader: false});
                }
            }).catch(error => {
            console.log(error);
            this.setState({showLoader:false});
        });
    }
    fetchBillingConfiguration() {
        if(this.props.authentication.jwtToken) {
            fetch(this.props.api + '/blubillingConf', {
                headers: {
                    method: "GET",
                    mode: 'cors',
                    "X-AUTH-TOKEN": this.props.authentication.jwtToken
                }
            })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    console.log(json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else {
                        if(json && json.blubillingConfiguration){
                            this.setState({blubillingConf : json.blubillingConfiguration});
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    fetchAllDocTemplates(pageNumber){
        let activePageNumber = 0;
        if (pageNumber !== null && isNaN(pageNumber) === true)
            pageNumber.preventDefault();
        else if (pageNumber !== null && isNaN(pageNumber) === false) {
            activePageNumber = (parseInt(pageNumber + '', 10) - 1)
            this.setState({activeNumber:pageNumber});
        }
        console.log("==event=" + pageNumber + "======" + isNaN(pageNumber) + "====activePageNumber=" + activePageNumber);
        this.setState({showLoader:true});
        fetch(this.props.api + '/template?offset='+activePageNumber+"&limit="+50, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json !== undefined) {
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.setState({showLoader: false});
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({showLoader: false, redirectToForbiddenPage: true});
                    } else {
                        this.setState({docTempates: json.content, count: json.totalElements, activeNumber: pageNumber});
                        this.setState({showLoader: false});
                    }
                }
            }).catch(error => {
            console.log(error);
            this.setState({showLoader:false});
        });
    }
    handleDeleteTemplate(templateId, pageNumber, count){
        let url = '/template/'+templateId+'?offset='+pageNumber+'&max='+count;
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this Document template!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.setState({showLoader:true});
                fetch(this.props.api + url, {
                    method: 'delete',
                    mode: 'cors',
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json && json.isError === false) {
                            const {apiStatus}  = this.state;
                            apiStatus.isError = false;
                            apiStatus.message = json.message;
                            this.setState({ apiStatus: apiStatus})
                            this.fetchAllDocTemplates(json.offset);
                            this.setState({showLoader: false});
                        }else {
                            const {apiStatus}  = this.state;
                            apiStatus.isError = true;
                            apiStatus.message = json.messages;
                            this.setState({ apiStatus: apiStatus})
                            this.setState({showLoader:false});
                            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                                this.props.onLogoutClick(json.message);
                            }
                        }
                    }).catch(error => {
                    this.setState({showLoader:false});
                    console.log(error);
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })

    }
    handleKeyPress(id,e) {
        if (!e.shiftKey){
            const domForm = ReactDOM.findDOMNode(e).childNodes[0].getElementsByClassName(id);
            const domFormSubmit = domForm.item(0);
            domFormSubmit.submit()
        }
    }
    refreshPageData(event) {
        this.setState({docTempates: []});
        this.setState({activeNumber: 1});
        this.setState({ count:0});
        this.setState({    apiStatus: {
                isError: false,
                message: ''
            }});
        this.setState({showLoader:false});
        this.componentDidMount()
    }
    validateForm(fieldName, value, disableBtn) {
        console.log("Inside validateForm");
        console.log("fieldName=" + fieldName + ", value=" + value + ", disableBtn=" + disableBtn);
        switch (fieldName) {
            case 'templateName': {
                let objError = AppConstant.validateInput(fieldName, value, true, null, null, null, 100, 3);
                console.log("Inside templateName " + objError);
                console.log(objError);
                if (objError !== null && objError.isError === true) {
                    this.setState({templateNameError: objError, disabledButton: true});
                    if (disableBtn !== null)
                        disableBtn = true
                } else {
                    this.setState({templateNameError: null, disabledButton: false})
                }
                break;
            }
            case 'description': {
                let objError = AppConstant.validateInput(fieldName, value, true, null, null, null, 500, 3);
                console.log("Inside description " + objError);
                console.log(objError);
                if (objError !== null && objError.isError === true) {
                    this.setState({descriptionError: objError, disabledButton: true});
                    if (disableBtn !== null)
                        disableBtn = true
                } else {
                    this.setState({descriptionError: null, disabledButton: false})
                }
                break;
            }
            case 'numberOfRecipient': {
                let objError = AppConstant.validateInput(fieldName, value, true, null, null, null, null, null);
                console.log("Inside numberOfRecipient " + objError);
                if (objError !== null && objError.isError === true) {
                    this.setState({numberOfRecipientError: objError, disabledButton: true});
                    if (disableBtn !== null)
                        disableBtn = true
                } else {
                    this.setState({numberOfRecipientError: null, disabledButton: false})
                }
                break;
            }
            default:
                if (disableBtn !== null)
                    disableBtn = false;
                break;
        }
        return disableBtn;
    }
    handleSubmit(event){
        event.preventDefault();
        let disablebtn = false;
        disablebtn = this.validateForm('templateName', this.state.submitTemplate.templateName, disablebtn);
        disablebtn = this.validateForm('description', this.state.submitTemplate.description, disablebtn);
        disablebtn = this.validateForm('numberOfRecipient', this.state.submitTemplate.numberOfRecipient, disablebtn);
        delete this.state.submitTemplate["attachments"];
        this.setState({disabledButton: disablebtn});
        if (disablebtn === false) {
            this.setState({showLoader:true});
            fetch(this.props.api + "/template/" + this.state.submitTemplate.id + "/copy", {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.submitTemplate),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json && json.isError === false) {
                        const {apiStatus}  = this.state;
                        apiStatus.isError = false;
                        apiStatus.message = json.message;
                        apiStatus.messages = json.messages;
                        this.setState({disabledButton: false, apiStatus: apiStatus});
                        this.setState({showLoader:false});
                        this.fetchAllDocTemplates(1)
                        $(".inmodal").trigger('click');
                    } else {
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        }else{
                            const {apiStatus1}  = this.state;
                            apiStatus1.isError = true;
                            apiStatus1.message = json.message;
                            this.setState({disabledButton: false, apiStatus1: apiStatus1});
                            this.setState({showLoader:false});
                        }
                    }
                })
                .catch(error => {
                    const {apiStatus}  = this.state;
                    apiStatus.isError = true;
                    apiStatus.message = error;
                    this.setState({disabledButton: false, apiStatus: apiStatus});
                    this.setState({showLoader:false})
                    console.log(error);
                });
        }
    }
    handleShowAdvanceOptions(){
        this.setState({showDiv: !this.state.showDiv})
    }
    render() {
        let _this = this;
        return (
            <div className="wrapper animated fadeInRight">

                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                        {/*<div className="ibox float-e-margins">*/}
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('docTemplatelist.templatesListHeader')}</p>
                                <div className="pull-right text-right">
                                    <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                                          redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                                    {(_this.state.loggedInUser && _this.state.loggedInUser.userRoles && _this.state.loggedInUser.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER")))  ?
                                        <form action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post">
                                            <input type="hidden" name="token" value={this.props.jwtToken} />
                                            <input type="hidden" name="pageUrl" value="/esignature/createDocTemplate" />
                                            <input type="hidden" name="erpRequest" value="true" />
                                            <input type="submit" value={_this.props.msg('docTemplatelist.button.add')} className="btn btn-primary" name="Add New Template"/>
                                        </form> : ''
                                    }

                                </div>
                            </div>
                            {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                            <div className="table-box table-responsive p-m">
                                <div style={{'textAlign':'center','display':''}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                    <br/>
                                </div>

                                <table className="table table-condensed-xs">
                                    <thead>
                                    <tr>
                                        <th className="header text-left">{_this.props.msg('table.th.name')}</th>
                                        <th className="header text-left">{_this.props.msg('table.th.description')}</th>
                                        <th className="header text-left">{_this.props.msg('table.th.attachments')}</th>
                                        <th className="header text-left" style={{width: '85px'}}>{_this.props.msg('table.th.created')}</th>
                                        <th className="header text-left"  style={{width:"25%"}}>{_this.props.msg('table.th.action')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.docTempates && this.state.docTempates.map(function(template, index){
                                        return (
                                            <tr key={Math.random()}>
                                                <td className="text-left">
                                                    {template.templateName}
                                                </td>
                                                <td className="text-left">{template.description}</td>
                                                <td className="text-left">
                                                    {
                                                        template.attachments && template.attachments.map(function(at){
                                                            return <p key={Math.random()} >{at.originalName}</p>
                                                        })
                                                    }
                                                </td>
                                                <td className="text-left">
                                                    {moment(template.dateCreated).format(_this.props.organization.jsDateFormat)}
                                                </td>
                                                <td className="text-left">
                                                                <Link to={'/getsignature/'+template.id} className="btn btn-primary btn-sm m-r-xxs"  style={{ whiteSpace:'nowrap'}} title="Create Signature Request with this Template" >
                                                                    Get Signature</Link>

                                                                {(_this.state.loggedInUser && _this.state.loggedInUser.userRoles && _this.state.loggedInUser.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER")))  ?
                                                                    <form ref="form" style={{display:'inline-block'}}
                                                                          className={'m-r-xxs '+template.id}
                                                                          action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post">
                                                                        <input type="hidden" name="token" value={_this.props.jwtToken} />
                                                                        <input type="hidden" name="pageUrl" value={'/esignature/editDocTemplatePage?id='+template.id} />
                                                                        <input type="hidden" name="erpRequest" value="true" />
                                                                        <button type="button" onClick={(e)=>_this.handleKeyPress(template.id,_this)} title="Edit this template" className="btn btn-white btn-sm">
                                                                            <i className="fa fa-edit"></i>
                                                                            <span className="hidden-xs hidden-sm"> Edit</span></button>
                                                                    </form>
                                                                    : ''
                                                                }

                                                                {(_this.state.loggedInUser && _this.state.loggedInUser.userRoles && _this.state.loggedInUser.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER")))  ?
                                                                <button type="button" onClick={(e)=>_this.handleDeleteTemplate(template.id, _this.state.activeNumber, _this.state.count)}
                                                                   title="Delete the template" className="btn btn-white btn-sm m-r-xxs">
                                                                    <i className="fa fa-trash"></i>
                                                                    <span className="hidden-xs hidden-sm"> Delete</span>
                                                                </button>
                                                                : ''
                                                            }
                                                                {(_this.state.loggedInUser  && _this.state.loggedInUser.userRoles && _this.state.loggedInUser.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER")))  ?
                                                                <button type="button" className="btn btn-white btn-sm m-r-xxs" title="Make a copy of Template" data-toggle="modal" data-target="#myModal2"
                                                                    onClick={(e)=>_this.copyTemplate(template.id,_this)}>
                                                                    <i className="fa fa-copy"></i>
                                                                    <span className="hidden-xs hidden-sm"> Copy</span>
                                                                </button>
                                                                : ''
                                                            }
                                                            {(_this.state.loggedInUser && _this.state.loggedInUser.userRoles && _this.state.loggedInUser.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER")))  ?
                                                            <Link to={'/template/'+template.id+'/users'}  className="btn btn-white btn-sm"  title="View and Map user with template" >
                                                                Users
                                                            </Link> : ''
                                                        }
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                               <tfoot>
                               <tr>
                                   <td colSpan="6" className="footable-visible">
                                <Pagination
                                    activePage={this.state.activeNumber}
                                    itemsCountPerPage={50}
                                    totalItemsCount={this.state.count}
                                    pageRangeDisplayed={5}
                                    onChange={this.fetchAllDocTemplates}
                                />

                                      </td>
                                     </tr>
                                </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal inmodal" id="myModal2" tabIndex="-1" role="dialog" aria-hidden="true" style={{display:"none"}}>
                    <div className="modal-dialog">
                        <div className="modal-content animated flipInY">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">Close</span></button>
                                <h4 className="modal-title">Copy Template</h4>
                            </div>
                            <form onSubmit={this.handleSubmit} className="form-horizontal" autoComplete="off">
                                <div className="modal-body">
                                    <Errors errorObject={this.state.apiStatus1}/>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="col-lg-4 control-label"
                                                           style={{textAlign:'left'}}>Name<RequiredAstrisk/></label>

                                                    <div className="col-lg-7">
                                                        <input type="text" className="form-control" id="templateName"
                                                               name="templateName" onChange={this.handleChange}
                                                               value={this.state.submitTemplate?this.state.submitTemplate.templateName:''}
                                                               maxLength="100" minLength="3"/>
                                                        <Errors errorObject={this.state.templateNameError}/>
                                                        <br/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="col-lg-4 control-label"
                                                           style={{textAlign:'left'}}>Description<RequiredAstrisk/></label>

                                                    <div className="col-lg-7">
                                                        <input type="text" className="form-control" id="description"
                                                               name="description" onChange={this.handleChange}
                                                               value={this.state.submitTemplate?this.state.submitTemplate.description:''}
                                                               maxLength="500" minLength="3"/>
                                                        <Errors errorObject={this.state.descriptionError}/>
                                                        <br/>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-md-12">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="col-lg-4 control-label"
                                                           style={{textAlign:'left'}}>No Of Recipient<RequiredAstrisk/></label>

                                                    <div className="col-lg-7">
                                                        <input type="number" className="form-control" id="numberOfRecipient"
                                                               name="numberOfRecipient" onChange={this.handleChange}
                                                               value={this.state.submitTemplate?this.state.submitTemplate.numberOfRecipient:''}
                                                        />
                                                        <Errors errorObject={this.state.numberOfRecipientError}/>
                                                        <br/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="col-lg-4 control-label"></label>
                                                    <div className="col-lg-7">
                                                        <a style={{textDecoration: 'underline'}}
                                                           onClick={this.handleShowAdvanceOptions}>Show / Hide Advanced
                                                            Options</a></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="getsignatureRequest"
                                             style={{display: this.state.showDiv === false ? 'none' : 'block'}}>
                                            <div className="col-md-12">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('table.th.enableRequesterAsRecipient')}</label>

                                                        <div className="col-lg-8 m-t">
                                                            <input
                                                                type="checkbox" id="enableRequesterAsRecipient"
                                                                name="enableRequesterAsRecipient"
                                                                checked={_this.state.submitTemplate ? _this.state.submitTemplate.enableRequesterAsRecipient : false}
                                                                onChange={(e) => _this.checkBoxChange(_this.state.submitTemplate.enableRequesterAsRecipient, 'enableRequesterAsRecipient')}/>
                                                            &nbsp;&nbsp;{_this.props.msg('table.th.enableRequesterAsRecipientInfo')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {_this.state.blubillingConf.enableCreateCustomer === true ?
                                                <div className="col-md-12">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="col-lg-4 control-label"
                                                                   style={{textAlign: 'left'}}>{_this.props.msg('table.th.createCreateCustomerOnSigning')}</label>

                                                            <div className="col-lg-8 m-t">
                                                                <input
                                                                    type="checkbox" id="disableExportCustomer"
                                                                    name="disableExportCustomer"
                                                                    checked={_this.state.submitTemplate ? _this.state.submitTemplate.disableExportCustomer : false}
                                                                    onChange={(e) => _this.checkBoxChange(_this.state.submitTemplate.disableExportCustomer, 'disableExportCustomer')}/>
                                                                &nbsp;&nbsp;{_this.props.msg('table.th.createCustomerOnSigningInfo')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ''
                                            }
                                            {_this.state.blubillingConf.allowCreateOrder === true ?
                                                <div className="col-md-12">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="col-lg-4 control-label"
                                                                   style={{textAlign: 'left'}}>{_this.props.msg('table.th.createOrderOnSigning')}</label>

                                                            <div className="col-lg-8 m-t">
                                                                <input
                                                                    type="checkbox" id="createOrderOnSigning"
                                                                    name="createOrderOnSigning"
                                                                    checked={_this.state.submitTemplate ? _this.state.submitTemplate.createOrderOnSigning : false}
                                                                    onChange={(e) => _this.checkBoxChange(_this.state.submitTemplate.createOrderOnSigning, 'createOrderOnSigning')}/>
                                                                &nbsp;&nbsp;{_this.props.msg('table.th.createOrderOnSigningInfo')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ''
                                            }
                                            {_this.state.blubillingConf.allowCreateOrder === true ?
                                                <div className="col-md-12">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="col-lg-4 control-label"
                                                                   style={{textAlign: 'left'}}>{_this.props.msg('table.th.createInvoice')}</label>

                                                            <div className="col-lg-8 m-t">
                                                                <input
                                                                    type="checkbox" id="createInvoice"
                                                                    name="createInvoice"
                                                                    checked={_this.state.submitTemplate ? _this.state.submitTemplate.createInvoice : false}
                                                                    onChange={(e) => _this.checkBoxChange(_this.state.submitTemplate.createInvoice, 'createInvoice')}/>
                                                                &nbsp;&nbsp;{_this.props.msg('table.th.createInvoiceInfo')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ''
                                            }
                                            {/*enable ach start*/}
                                            <div className="col-md-12">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('table.th.achCardOptional')}</label>

                                                        <div className="col-lg-8 m-t">
                                                            <input
                                                                type="checkbox" id="eitherAchOrCardRequired"
                                                                name="eitherAchOrCardRequired"
                                                                checked={_this.state.submitTemplate ? _this.state.submitTemplate.eitherAchOrCardRequired : false}
                                                                onChange={(e) => _this.checkBoxChange(_this.state.submitTemplate.eitherAchOrCardRequired, 'eitherAchOrCardRequired')}/>
                                                            &nbsp;&nbsp;
                                                            <span>{_this.props.msg('table.th.achCardOptionallabel')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*enable ach end*/}
                                            <div className="col-md-12">
                                                <div className="col-md-12">
                                                    <div className="form-group" style={{
                                                        marginBottom: "5px",
                                                        display: (_this.state.blubillingConf.enablePayments === true ? 'block' : 'none')
                                                    }}>
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('table.th.processPayment')}</label>
                                                        <div className="col-lg-8">
                                                            <label className="radio-inline" style={{display: 'block'}}>
                                                                <input
                                                                    type="radio" id="processPaymentAfterSigning"
                                                                    name="processPaymentAfterSigning"
                                                                    checked={_this.state.submitTemplate && _this.state.submitTemplate.processPaymentAfterSigning === 'PROCESS_PAYMENT_AFTER_SIGNED' ? true : false}
                                                                    onChange={(e) => _this.changeRadioButton('PROCESS_PAYMENT_AFTER_SIGNED', 'processPaymentAfterSigning')}/>&nbsp;&nbsp;
                                                                <span style={{
                                                                    color: '#676a6c',
                                                                    marginLeft: '-7px'
                                                                }}>{_this.props.msg('table.th.processPaymentlabel')}</span>
                                                            </label>
                                                            <label className="radio-inline" style={{marginLeft: '0px'}}>
                                                                <input
                                                                    type="radio" id="processPaymentAfterSigning"
                                                                    name="processPaymentAfterSigning"
                                                                    checked={_this.state.submitTemplate && _this.state.submitTemplate.processPaymentAfterSigning === 'DISABLED' ? true : false}
                                                                    onChange={(e) => _this.changeRadioButton('DISABLED', 'processPaymentAfterSigning')}/>&nbsp;&nbsp;
                                                                <span style={{
                                                                    color: '#676a6c',
                                                                    marginLeft: '-7px'
                                                                }}>{_this.props.msg('table.th.disableProcessPaymentlabel')}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-white" data-dismiss="modal">{_this.props.msg('form.label.cancelButton')}</button>
                                    <button type="Submit" className="btn btn-primary" disabled={this.state.disabledButton===true}>{_this.props.msg('form.label.submit')}</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
                <style dangerouslySetInnerHTML = {{__html: `
                p { margin:0 0 2px;}
                .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
                  padding: 4px;
                }
                `}} />
            </div>
        )
    }

}
export default DocTemplateList;


// WEBPACK FOOTER //
// ./src/components/template/DocTemplateList.js